export const COLOUR_BLUE = '#0095E6';
export const COLOUR_BRIGHT_BLUE = '#3FE4FB';
export const COLOUR_GREEN = '#10DAC1';
export const COLOUR_ORANGE = '#FD9A05';
export const COLOUR_PINK = '#FF73C7';
export const COLOUR_PURPLE = '#9664FF';
export const COLOUR_RED = '#EB4869';

/**
 * Freezing to prevent values being overridden accidentally at runtime
 */
export const BRAND_COLOURS = Object.freeze({
    blue: COLOUR_BLUE,
    brightBlue: COLOUR_BRIGHT_BLUE,
    green: COLOUR_GREEN,
    orange: COLOUR_ORANGE,
    pink: COLOUR_PINK,
    purple: COLOUR_PURPLE,
});
